import React from "react";

/**
 * Cabsab brand logo — renders the customer-supplied artwork at /logo.png.
 * No design modifications. We only trimmed the surrounding whitespace from
 * the source file so the logo can render at a readable size in tight UI
 * areas like the navbar.
 *
 * Variants:
 *   • full  (default) — pin + cab + tagline
 *   • icon            — pin + cab only (good for compact spots / favicon)
 */
const Logo = ({ heightClass = "h-14", variant = "full", alt = "Cabsab — Travel More. Pay Less." }) => {
  const src = variant === "icon" ? "/logo-icon.png?v=2" : "/logo.png?v=2";
  return (
    <img
      src={src}
      alt={alt}
      className={`${heightClass} w-auto select-none block`}
      draggable="false"
    />
  );
};

export default Logo;
